import * as React from "react";
import {Fragment, useEffect} from "react";
import {Link, useNavigate} from "react-router-dom";

import {ROUTES} from "../../helpers/constants";
import {useAppDispatch, useAppSelector} from "../../redux/storeHooks";
import {clearDownloads, fetchDownloads, setDownloadsPaginationPage} from "./downloadsSlice";
import Loader from "../ui/Loader";
import EBookItem from "../eLibrary/EBookItem";
import Pagination from "../ui/Pagination";

const DownloadsPage = () => {

  const {downloads, downloadsStatus, pagination} = useAppSelector((store) => store.downloadsState);
  const {currentPage, postsPerPage} = pagination;

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchDownloads({navigate, currentPage, postsPerPage}));
  }, [dispatch, navigate, currentPage, postsPerPage]);

  useEffect(() => {
    return () => {
      dispatch(clearDownloads())
    }
  }, [dispatch]);

  const setPaginationStep = (currentPage: number) => {
    dispatch(setDownloadsPaginationPage(currentPage))
  }

  return (
    <section className="section margin-b-50">
      <div className="container">
        <span className="block h5 text-center red2">Downloads</span>
        <h2 className="h2 text-center black max-520 auto">Your Downloaded Ebooks</h2>
        <p className="margin-b-30 max-520 auto text-center">
          All the materials you've downloaded are accessible around the clock in your account. Feel free to acquire fresh books and broaden your collection of professional skills at any time!
        </p>
        {downloads.length ? (
          <Fragment>
            <ul className="member-books flex flex--wrap flex--top fix-ul">
              {downloads.map(eBook => <EBookItem key={eBook.title} eBook={eBook}/>)}
            </ul>
            <Pagination pagination={pagination} setPaginationStep={setPaginationStep}/>
            {downloadsStatus === "loading" ? (
              <div className="overlay overlay--visible">
                <Loader className={"member-loader--white"}/>
              </div>
            ) : null}
          </Fragment>
        ) : (downloadsStatus === "loading") ? (
          <div className="min-h-500 relative">
            <Loader/>
          </div>
        ) : (
          <Fragment>
            <p className="margin-b-30 max-520 auto text-center">
              You have no any ebooks downloaded
            </p>
            <div className="text-center">
              <Link to={ROUTES.eLibrary} className={"ui-button ui-button--blue2"}>Go to Library</Link>
            </div>
          </Fragment>
        )}
      </div>
    </section>
  )
}

export default DownloadsPage
